import { RUB } from './format'

/**
 * Гаджет: простой парка.
 *
 * Машино-дни в ремонте и средняя длительность ремонта. Процент от
 * календаря парка важнее абсолютных дней: он сравним между парками
 * разного размера и между периодами разной длины.
 */
export function DowntimeWidget({ data }) {
  if (!data.repairs && !data.open_now) {
    return <p className="widget-empty">За период ремонтов не было</p>
  }

  return (
    <div className="downtime">
      <div className="downtime__pair">
        <span className="downtime__block">
          <span className="downtime__value">
            {data.downtime_pct != null ? `${data.downtime_pct}%` : '—'}
          </span>
          <span className="downtime__label">календаря парка в ремонте</span>
        </span>
        <span className="downtime__block">
          <span className="downtime__value downtime__value--muted">
            {data.mttr_days != null ? `${data.mttr_days} дн.` : '—'}
          </span>
          <span className="downtime__label">средний ремонт</span>
        </span>
      </div>

      <ul className="downtime__facts">
        <li>
          <span>Ремонтов за период</span>
          <b>{data.repairs}</b>
        </li>
        <li>
          <span>Открыто сейчас</span>
          <b>{data.open_now}</b>
        </li>
        <li>
          <span>Машино-дней простоя</span>
          <b>{data.downtime_days}</b>
        </li>
        {data.cost > 0 && (
          <li>
            <span>Потрачено на ремонт</span>
            <b>{RUB.format(data.cost)} ₽</b>
          </li>
        )}
      </ul>

      {data.undated > 0 && (
        <p className="widget-note">
          У {data.undated} ремонтов не проставлены даты — в среднюю длительность
          они не вошли, реальный простой выше.
        </p>
      )}
    </div>
  )
}
